var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 92.6",
    style: {
      enableBackground: "new 0 0 142 92.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-english{fill:#084CA1;}\n\t.st1-english{fill:#FFFFFF;}\n\t.st2-english{fill:#ED1C24;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    className: "st0-english",
    width: 141,
    height: 92.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1-english",
    d: "M141.5,0h-17.7L87.1,24.1V0H54.8v25.1L15.9,0H0.5v12.5l27.9,18.1H0.5v32.1h27.6L0.5,80.9v11.7h18.3l36-23.7 v23.7h32.4V68.5l37.2,24.1h17.2V81l-28.3-18.3h28.3V30.6h-28.2l28.2-18.5V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2-english",
    d: "M45.9,30.6L0.5,0v8.1l33.9,22.5H45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2-english",
    d: "M96.2,62.7l45.3,29.9l0,0v-7.5l-33.9-22.4H96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2-english",
    d: "M54.8,62.7h-9.3L0.5,92.6h10.8l43.5-28.5V62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2-english",
    d: "M87.1,30.6h8.7l45.7-29.8V0h-10.3L87.1,28.7V30.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2-english",
    points: "141.5,37.4 80.2,37.4 80.2,0 61.7,0 61.7,37.4 0.5,37.4 0.5,55.9 61.7,55.9 61.7,92.6 80.2,92.6  80.2,55.9 141.5,55.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.4929674cb4bb4f616e3638624d9c6932.svg";
export { ForwardRef as ReactComponent };